<template>
  <component v-if="currentComponent" :is="currentComponent" />
</template>

<script>
import OrderPage from "@/views/orders/OrderPage.vue";
import TailoringOrderPage from "@/views/orders/TailoringOrderPage.vue";

export default {
  name: "OrderPageRouter",
  components: {
    OrderPage,
    TailoringOrderPage,
  },
  data() {
    return {
      orderFulfillmentKind: this.$route.query.fulfillmentKind || null,
    };
  },
  computed: {
    currentComponent() {
      if (!this.orderFulfillmentKind) {
        return null;
      }

      return this.orderFulfillmentKind === "Tailoring"
        ? "TailoringOrderPage"
        : "OrderPage";
    },
  },
  watch: {
    "$route.fullPath": {
      handler() {
        this.resolveOrderKind();
      },
      immediate: true,
    },
  },
  methods: {
    async resolveOrderKind() {
      const routeFulfillmentKind = this.$route.query.fulfillmentKind;
      const routeKind = this.$route.params.kind || this.$route.query.kind;

      if (routeFulfillmentKind) {
        this.orderFulfillmentKind = routeFulfillmentKind;
        return;
      }

      if (routeKind) {
        this.orderFulfillmentKind = "Standard";
        return;
      }

      const id = this.$route.params.id;
      if (!id) {
        this.orderFulfillmentKind = "Standard";
        return;
      }

      const response = await this.$store.dispatch("getFilter", {
        table: "Order",
        body: { id, rootColumn: "Id" },
      });
      const order = response.data.data?.[0];
      this.orderFulfillmentKind = order?.fulfillmentKind || "Standard";
    },
  },
};
</script>
